import React from 'react'
import OurTeam from '../../comp/our-team/OurTeam'

const Teams = () => {
  return (
    <div>
      <OurTeam />
    </div>
  )
}

export default Teams
